<template>
  <!-- 進場提示（設計稿 EntryDialog）：置中 modal → 標題 / cyan 左框開放期間 / 純文字提醒 / 灰底 footer -->
  <div class="ur-sel-unit-overlay" @click.self="$emit('close')">
    <div class="ur-sel-intro-box">
      <div class="ur-sel-intro-content">
        <h3 class="ur-sel-intro-title">{{ $t('URBANRENEWAL_SELECT.DIALOG.INTRO_TITLE') }}</h3>

        <div v-if="periodText" class="ur-sel-intro-period">
          <span class="ur-sel-intro-period-label">{{ $t('URBANRENEWAL_SELECT.DIALOG.INTRO_PERIOD_LABEL') }}</span>
          <span class="ur-sel-intro-period-value">{{ periodText }}</span>
        </div>

        <p class="ur-sel-intro-text">{{ $t('URBANRENEWAL_SELECT.DIALOG.INTRO_BODY') }}</p>
      </div>

      <div class="ur-sel-intro-footer">
        <button class="ur-sel-intro-btn" type="button" @click="$emit('close')">
          {{ $t('URBANRENEWAL_SELECT.DIALOG.INTRO_OK') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import UrbanRenewalSelectService from '@/services/UrbanRenewalSelectService';

export default {
  name: 'UrbanRenewalSelectIntroDialog',

  computed: {
    project() {
      return this.$store.state.urbanRenewalSelect.project || UrbanRenewalSelectService.getProject();
    },
    periodText() {
      const p = this.project;
      if (!p) return '';
      const start = p.selection_start;
      const end = p.selection_deadline;
      if (!start && !end) return '';
      return this.$t('URBANRENEWAL_SELECT.DIALOG.INTRO_PERIOD_RANGE', {
        start: start || '—',
        end: end || '—',
      });
    },
  },
};
</script>
